/**
 * Provenance de l'adresse du bloc « Contenu externe ».
 *
 * Trois sources, comme la cible d'un bouton : un lien de la banque, une
 * variable du CRM, ou une adresse saisie à la main. Quelle que soit la source,
 * l'adresse **rendue** est copiée dans les props — le site publié ne résout
 * rien à l'affichage (même règle que `buttonLink.js` et que les nœuds
 * variable d'un texte).
 *
 *   { source: 'bank',     url, linkId }
 *   { source: 'variable', variableKey, variableName, variableValue, variableOrphan? }
 *   { source: 'url',      url }
 */

export const EMBED_SOURCES = ['bank', 'variable', 'url'];

export const EMBED_SOURCE_LABELS = {
  bank: 'Un lien de la banque',
  variable: 'Une variable',
  url: 'Une adresse web',
};

/**
 * Source d'un bloc, déduite de ses props quand elle n'y est pas écrite.
 *
 * Les blocs déjà en base n'ont pas de prop `source` — et elle ne peut pas être
 * mise dans `defaultProps`, que Puck fusionne **sous** les props stockées : un
 * défaut y masquerait le `linkId` de ces blocs-là. D'où le repli ici.
 */
export function embedSourceKind(props = {}) {
  if (EMBED_SOURCES.includes(props.source)) return props.source;
  if (props.variableKey) return 'variable';
  if (props.linkId) return 'bank';
  return 'url';
}

/** Adresse effective : celle de la variable quand la source en est une. */
export function embedUrl(props = {}) {
  return embedSourceKind(props) === 'variable'
    ? String(props.variableValue || '')
    : String(props.url || '');
}

/**
 * Props à écrire en changeant de source : celles des autres sources sont
 * vidées. Un `linkId` resté derrière ferait réécraser l'adresse par
 * « Rafraîchir les liens », alors que le bloc n'y est plus branché.
 */
export function embedSourceReset(source) {
  return {
    source,
    url: '',
    linkId: '',
    variableKey: '',
    variableName: '',
    variableValue: '',
    variableOrphan: false,
  };
}
